import * as React from "react";

import { Input, type InputProps } from "./input";

// Native date control — <input type="date"> reusing the Input styling (border,
// radius, focus ring, error state). No calendar/date-picker dependency.
export type DateInputProps = Omit<InputProps, "type">;

const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>((props, ref) => (
  <Input ref={ref} type="date" {...props} />
));
DateInput.displayName = "DateInput";

export { DateInput };
